import { createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "app/auth/base";
import { closeLoading, openLoading } from "app/store/trackingApp/loadingSlice";
import { openToast } from "app/store/trackingApp/toastSlice";
import { openModalError } from "app/store/trackingApp/modalErrorSlice";

export const getGruposDeAcesso = createAsyncThunk(
  "acessosApp/gruposDeAcesso/getGruposDeAcesso",
  async (data: object, { dispatch }) => {
    let response;
    let responseAllMenus;
    let responseAllApelidos;
    dispatch(openLoading());
    try {
      response = await API.get("/grupo-acesso", { params: data });
      responseAllMenus = await API.get("/menu", {
        params: { pagina: 1, itensPorPagina: 5000 },
      });
      responseAllApelidos = await API.get("/transportadoraapelidos");
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Não foi possível buscar os grupos de acesso!",
          text: "Se certifique que os dados digitados estão corretos",
          btnLabel: "Voltar",
        })
      );
      console.error(err.response);
    }
    dispatch(closeLoading());
    return {
      responseData: response.data,
      responseAllMenusData: responseAllMenus.data,
      responseAllApelidos: responseAllApelidos.data,
    };
  }
);

export const getMenusDeGrupo = createAsyncThunk(
  "acessosApp/gruposDeAcesso/getMenusDeGrupo",
  async (data: object, { dispatch }) => {
    let response;
    dispatch(openLoading());
    try {
      response = await API.get("/menu-acesso", { params: data });
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Não foi possível buscar os menus de grupos de acesso!",
          text: "Se certifique que os dados digitados estão corretos",
          btnLabel: "Voltar",
        })
      );
      console.error(err.response);
    }
    dispatch(closeLoading());
    return response.data;
  }
);

export const saveGrupoDeAcesso = createAsyncThunk(
  "acessosApp/gruposDeAcesso/saveGrupoDeAcesso",
  async (data: object, { dispatch, getState }) => {
    const requestGetParams: any = getState();
    try {
      await API.post("/grupo-acesso", data);
      dispatch(
        openToast({
          severity: "success",
          title: "Grupo de acesso cadastrado",
        })
      );
      dispatch(
        getGruposDeAcesso(
          requestGetParams.acessosApp.gruposDeAcesso.requestGetParams
        )
      );
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Não foi possível cadastrar esse grupo de acesso!",
          text: "Se certifique que os dados digitados estão corretos",
          btnLabel: "Voltar",
        })
      );
      console.error(err.response);
    }
    return {};
  }
);

export const saveMenuDeGrupo = createAsyncThunk(
  "acessosApp/gruposDeAcesso/saveMenuDeGrupo",
  async (data: any, { dispatch, getState }) => {
    const { id } = data;
    const requestGetParamsMenusDeGrupo: any = getState();
    const idRequestBefore =
      requestGetParamsMenusDeGrupo.acessosApp.gruposDeAcesso
        .requestGetParamsMenusDeGrupo[id];
    try {
      await API.post("/menu-acesso", data);
      dispatch(
        openToast({
          severity: "success",
          title: "Grupo de acesso cadastrado",
        })
      );
      dispatch(
        getMenusDeGrupo(
          idRequestBefore
            ? idRequestBefore
            : { grupoAcesso: id, pagina: 1, itensPorPagina: 15 }
        )
      );
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Não foi possível cadastrar esse menu ao grupo de acesso!",
          text: "Se certifique que os dados digitados estão corretos",
          btnLabel: "Voltar",
        })
      );
      console.error(err.response);
    }
    return {};
  }
);

export const editGrupoDeAcesso = createAsyncThunk(
  "acessosApp/gruposDeAcesso/editGrupoDeAcesso",
  async (data: object, { dispatch, getState }) => {
    const requestGetParams: any = getState();
    try {
      await API.put("/grupo-acesso", data);
      dispatch(
        openToast({
          severity: "success",
          title: "Grupo de acesso editado",
        })
      );
      dispatch(
        getGruposDeAcesso(
          requestGetParams.acessosApp.gruposDeAcesso.requestGetParams
        )
      );
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Não foi possível editar esse menu do grupo de acesso!",
          text: "Se certifique que os dados digitados estão corretos",
          btnLabel: "Voltar",
        })
      );
      console.error(err.response);
    }
    return {};
  }
);

export const editMenuDeGrupo = createAsyncThunk(
  "acessosApp/gruposDeAcesso/editMenuDeGrupo",
  async (data: any, { dispatch, getState }) => {
    const requestGetParamsMenusDeGrupo: any = getState();
    const { id } = data;
    try {
      await API.put("/menu-acesso", data);
      dispatch(
        openToast({
          severity: "success",
          title: "Grupo de acesso editado",
        })
      );
      dispatch(
        getMenusDeGrupo(
          requestGetParamsMenusDeGrupo.acessosApp.gruposDeAcesso
            .requestGetParamsMenusDeGrupo[id]
        )
      );
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Não foi possível editar o menu do grupo de acesso!",
          text: "Se certifique que os dados digitados estão corretos",
          btnLabel: "Voltar",
        })
      );
      console.error(err.response);
    }
    return {};
  }
);

export const deleteGrupoDeAcesso = createAsyncThunk(
  "acessosApp/gruposDeAcesso/deleteGrupoDeAcesso",
  async (data: any, { dispatch, getState }) => {
    const requestGetParams: any = getState();
    const { idGrupo } = data;
    try {
      await API.delete(`/grupo-acesso?idGrupo=${idGrupo}`);
      dispatch(
        openToast({
          severity: "success",
          title: "Grupo de acesso removido",
        })
      );
      dispatch(
        getGruposDeAcesso(
          requestGetParams.acessosApp.gruposDeAcesso.requestGetParams
        )
      );
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Não foi possível remover o grupo de acesso!",
          text: "Se certifique que a solicitação está correta",
          btnLabel: "Voltar",
        })
      );
      console.error(err.response);
    }
    return {};
  }
);

export const deleteMenuDeGrupo = createAsyncThunk(
  "acessosApp/gruposDeAcesso/deleteMenuDeGrupo",
  async (data: any, { dispatch, getState }) => {
    const requestGetParamsMenusDeGrupo: any = getState();
    const { id, idMenu } = data;
    try {
      await API.delete(`/menu-acesso?id=${id}&idGrupo=${idMenu}`);
      dispatch(
        openToast({
          severity: "success",
          title: "Menu do grupo de acesso removido",
        })
      );
      dispatch(
        getGruposDeAcesso(
          requestGetParamsMenusDeGrupo.acessosApp.gruposDeAcesso
            .requestGetParamsMenusDeGrupo[id]
        )
      );
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Não foi possível remover o menu do grupo de acesso!",
          text: "Se certifique que a solicitação está correta",
          btnLabel: "Voltar",
        })
      );
      console.error(err.response);
    }
    return {};
  }
);
